<template>
  <div class="fileCardWrapper">
    <div class="cardLeft">
      <img :src="fileInfo.origin?.src || defaultIcon" alt="" class="cardImg" />
      <div class="fileName">
        {{ fileInfo.origin?.filename }}
      </div>
    </div>
    <div class="cardRight">
      <div v-if="!isLoading" class="fileInfo">
        <div class="cardCorner" @click="handleRemove">
          <span class="icon"></span>
        </div>
        <div class="infoBox">
          <p class="txt">原图</p>
          <p class="info">
            <span>{{ fileInfo.origin?.suffix }}</span>
            <span>{{ fileInfo.origin?.width }}x{{ fileInfo.origin?.height }}</span>
            <span>{{ fileInfo.origin?.size }}kb</span>
          </p>
        </div>
        <div class="infoBox" v-if="fileInfo.target">
          <p class="txt">压缩后</p>
          <p class="info">
            <span>{{ fileInfo.target?.suffix }}</span>
            <span>{{ fileInfo.target?.width }}x{{ fileInfo.target?.height }}</span>
            <span>{{ fileInfo.target?.size }}kb</span>
          </p>
        </div>
        <div class="btnGroups" v-if="fileInfo.target">
          <button class="btn" @click="handlePreview">预览</button>
          <button class="btn" @click="downloadImage">下载</button>
        </div>
      </div>
      <div v-else class="progressWrapper">
        <div class="progressBox">
          <div class="progress"></div>
        </div>
        <p>处理中...</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompressFileCard',
  components: {},
  props: {
    fileInfo: {
      type: Object,
      required: true,
      default: function () {
        return {
          origin: {},
          target: {}
        }
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultIcon: require('@/assets/img/default_icon.svg')
    }
  },
  methods: {
    handlePreview() {
      this.$emit('onPreview', this.fileInfo)
    },
    // 移除当前图片
    handleRemove() {
      this.$emit('remove', this.fileInfo)
    },
    // 下载当前压缩图片
    downloadImage() {
      this.$emit('download', this.fileInfo, this.file?.options)
    }
  }
}
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
